/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useNews } from '../../context/NewsContext';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { 
  RiCalendarLine, 
  RiEyeLine, 
  RiArrowRightLine,
  RiTimeLine,
  RiUserLine,
  RiLeafLine
} from 'react-icons/ri';
import './News.css';

const News = () => {
  const { featuredNews, news, loading, fetchNews, incrementView } = useNews();
  const [activeCategory, setActiveCategory] = useState('all');
  const [categories, setCategories] = useState([]);
  const [hoveredCard, setHoveredCard] = useState(null);

  useEffect(() => {
    fetchNews({ status: 'published' });
  }, [fetchNews]);

  useEffect(() => {
    const uniqueCategories = [...new Set(news?.map(item => item?.category))];
    setCategories(uniqueCategories);
  }, [news]);

  const filteredNews = activeCategory === 'all' 
    ? news?.filter(item => item?.status === 'published')
    : news?.filter(item => item?.category === activeCategory && item?.status === 'published');

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const handleReadMore = (id) => {
    incrementView(id);
  };

  const getImageUrl = (imageUrl) => {
  if (!imageUrl) return '/assets/img/placeholder.png';
  
  if (imageUrl.startsWith('/uploads')) {
    if (process.env.NODE_ENV === 'development') {
      return `http://localhost:5000${imageUrl}`;
    }
    const apiUrl = 'https://farmo.zuddo.biz/api';
    const backendOrigin = apiUrl.replace(/\/api\/?$/, '');
    return `${backendOrigin}${imageUrl}`;
  }
  if (imageUrl.startsWith('/assets/')) {
    return imageUrl;
  }
  return imageUrl;
};
  const getReadingTime = (content) => {
    const wordsPerMinute = 200;
    const wordCount = content?.split(/\s+/).length || 0;
    const minutes = Math.ceil(wordCount / wordsPerMinute);
    return minutes < 1 ? 1 : minutes;
  };

  return (
    <section className="farmo-news" id="news">
      <div className="farmo-news__container">
        <div className="farmo-news__header">
          <div className="farmo-news__header-content">
            <span className="farmo-news__subtitle">STORIES & UPDATES</span>
            <h1 className="farmo-news__title">
              Impact <span className="accent">Stories</span>
            </h1>
            <div className="farmo-news__divider">
              <span></span>
              <i className="ri-leaf-line"></i>
              <span></span>
            </div>
            <p className="farmo-news__description">
              Discover how we're transforming agriculture, empowering communities, 
              and building a food-secure future across South Sudan.
            </p>
          </div>

          <div className="farmo-news__filters">
            <button 
              className={`filter-btn ${activeCategory === 'all' ? 'active' : ''}`}
              onClick={() => setActiveCategory('all')}
            >
              All Stories
            </button>
            {categories.map((category, index) => (
              <button
                key={index}
                className={`filter-btn ${activeCategory === category ? 'active' : ''}`}
                onClick={() => setActiveCategory(category)}
              >
                {category}
              </button>
            ))}
          </div>
        </div>

        {featuredNews.length > 0 && (
          <div className="farmo-news__featured">
            <div className="featured-story">
              <div className="featured-story__image">
                <img 
                  src={getImageUrl(featuredNews[0].image_url)} 
                  alt={featuredNews[0].title}
                />
                <div className="featured-story__badge">
                  <RiLeafLine />
                  <span>Featured Story</span>
                </div>
              </div>
              <div className="featured-story__content">
                <div className="featured-story__meta">
                  <span className="featured-story__category">{featuredNews[0].category}</span>
                  <span className="featured-story__date">
                    <RiCalendarLine /> {formatDate(featuredNews[0].published_at)}
                  </span>
                </div>
                <h2 className="featured-story__title">{featuredNews[0].title}</h2>
                <p className="featured-story__summary">{featuredNews[0].summary}</p>
                <div className="featured-story__stats">
                  <span><RiEyeLine /> {featuredNews[0].views || 0} views</span>
                  <span><RiTimeLine /> {getReadingTime(featuredNews[0].content)} min read</span>
                </div>
                <Link 
                  to={`/news/${featuredNews[0].id}`} 
                  className="featured-story__link"
                  onClick={() => handleReadMore(featuredNews[0].id)}
                >
                  Read Full Story
                  <RiArrowRightLine />
                </Link>
              </div>
            </div>
          </div>
        )}

        {featuredNews.length > 1 && (
          <div className="farmo-news__secondary">
            {featuredNews.slice(1, 3).map(item => (
              <div key={item.id} className="secondary-story">
                <div className="secondary-story__image">
                  <img 
                    src={getImageUrl(item.image_url)} 
                    alt={item.title}
                  />
                </div>
                <div className="secondary-story__content">
                  <span className="secondary-story__category">{item.category}</span>
                  <h3 className="secondary-story__title">{item.title}</h3>
                  <div className="secondary-story__meta">
                    <span><RiCalendarLine /> {formatDate(item.published_at)}</span>
                  </div>
                  <Link 
                    to={`/news/${item.id}`} 
                    className="secondary-story__link"
                    onClick={() => handleReadMore(item.id)}
                  >
                    Read More <RiArrowRightLine />
                  </Link>
                </div>
              </div>
            ))}
          </div>
        )}

        {loading ? (
          <div className="farmo-news__loading">
            <div className="loading-spinner"></div>
            <p>Loading stories...</p>
          </div>
        ) : (
          <div className="farmo-news__grid">
            {filteredNews?.map((item, index) => (
              <article 
                key={item.id} 
                className={`news-card ${index === 0 ? 'news-card--large' : ''}`}
                onMouseEnter={() => setHoveredCard(item.id)}
                onMouseLeave={() => setHoveredCard(null)}
              >
                <div className="news-card__image">
                  <img 
                    src={getImageUrl(item.image_url)} 
                    alt={item.title}
                  />
                  <span className="news-card__category">{item.category}</span>
                </div>
                
                <div className="news-card__content">
                  <div className="news-card__meta">
                    <span className="news-card__date">
                      <RiCalendarLine /> {formatDate(item.published_at || item.created_at)}
                    </span>
                    <span className="news-card__read-time">
                      <RiTimeLine /> {getReadingTime(item.content)} min
                    </span>
                  </div>
                  
                  <h3 className="news-card__title">
                    <Link to={`/news/${item.id}`} onClick={() => handleReadMore(item.id)}>
                      {item.title}
                    </Link>
                  </h3>
                  
                  <p className="news-card__summary">{item.summary}</p>
                  
                  <div className="news-card__footer">
                    {item.author_name && (
                      <div className="news-card__author">
                        <div className="author-avatar">
                          <RiUserLine />
                        </div>
                        <span>{item.author_name}</span>
                      </div>
                    )}
                    <Link 
                      to={`/news/${item.id}`} 
                      className="news-card__link"
                      onClick={() => handleReadMore(item.id)}
                    >
                      Read Story <RiArrowRightLine />
                    </Link>
                  </div>
                </div>
              </article>
            ))}
          </div>
        )}

        {filteredNews?.length > 0 && (
          <div className="farmo-news__load-more">
            <button className="load-more-btn">
              <span>Load More Stories</span>
              <RiArrowRightLine />
            </button>
          </div>
        )}

        <div className="farmo-news__newsletter">
          <div className="newsletter-card">
            <div className="newsletter-icon">
              <i className="ri-mail-open-line"></i>
            </div>
            <h3>Stay Updated</h3>
            <p>Subscribe to our newsletter to receive the latest stories and updates from FARMO.</p>
            <form className="newsletter-form">
              <input type="email" placeholder="Enter your email address" />
              <button type="submit">Subscribe</button>
            </form>
            <p className="newsletter-note">We respect your privacy. Unsubscribe at any time.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default News;